import React, {Component} from 'react';
import {Col, Row, Button, FormControl} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
import Select   from 'react-select'
import {
    ADD_SELECTED_CONTRACTORS, CLEAR_SELECTED_CONTRACTORS
} from "actions/actionTypes";
import config from  '../../../../config';

export default class AMTSalesProductsSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        var selectedMarkets = _.isUndefined(this.props.location.query.Markets) ? [] : _.map(this.props.location.query.Markets.split(','), function (item) {
            var location = _.find(config.warehouseData, function (o) {
                return o.MarketName == item
            });
            if (location) {
                return {'value': item, 'label': location.MarketName}
            }
        })
        selectedMarkets = _.difference(selectedMarkets,config.allSubMarkets)

        console.log('label', _.get(this.props.location.query, 'inventory', 'n/a'));
        var inventory = _.find(config.inventoryOwnershipMap, {label: _.get(this.props.location.query, 'inventory')})
        var availability = _.find([{value: 'sold', label: 'Sold',}, {
            value: 'available',
            label: 'Available',
        }], {value: _.get(this.props.location.query, 'availability')})

        this.state = {
            filterOptions: {
                perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                fromPublishedAt: _.isUndefined(this.props.location.query.fromPublishedAt) ? moment().subtract(2, 'weeks') : moment(this.props.location.query.fromPublishedAt),
                toPublishedAt: _.isUndefined(this.props.location.query.toPublishedAt) ? '' : moment(this.props.location.query.toPublishedAt),
                inventory: inventory ? inventory : '',

                availability: availability ? availability : '',
                minPrice: _.isUndefined(this.props.location.query.minPrice) ? '' : this.props.location.query.minPrice,
                maxPrice: _.isUndefined(this.props.location.query.maxPrice) ? '' : this.props.location.query.maxPrice,
                searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,

                Markets: selectedMarkets
            }
        };

    };

    onMarketsSelect(options) {
        var updateOptions = {...this.state.filterOptions, Markets: options};
        this.setState({'filterOptions': updateOptions}, function () {
            this.props.search();
        });
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    getSearchParams(filtersChanged = {}) {

        console.log('this.state.filterOptions', this.state);
        var filterOptions = {...this.state.filterOptions, ...filtersChanged};

        var queryParams = {addFields: []};

        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if (filterOptions.fromPublishedAt && moment(filterOptions.fromPublishedAt, 'MM-DD-YYYY', true).isValid()) {
            queryParams.addFields.push('PublishedInShopifyChangeLogRecord')
            queryParams.fromPublishedAt = filterOptions.fromPublishedAt.toISOString()
        } else{
              this.props.displayMessage({
                'messageCode': 'Please, select Date Listed From',
            });
              return {queryParams:false}
        }
        if (filterOptions.toPublishedAt && moment(filterOptions.toPublishedAt, 'MM-DD-YYYY', true).isValid()) {
            queryParams.addFields.push('PublishedInShopifyChangeLogRecord')
            queryParams.toPublishedAt = filterOptions.toPublishedAt.toISOString()
        }
        if (filterOptions.maxPrice !== '') {
            queryParams.maxPrice = filterOptions.maxPrice;
        }

        if (filterOptions.minPrice !== '') {
            queryParams.minPrice = filterOptions.minPrice;
        }
        if (_.get(filterOptions, 'inventory.value')) {
            queryParams.inventory = [_.get(filterOptions, 'inventory.value')]
        }
        // if (filterOptions.perPage == 'all') {
        //     queryParams.all = true
        // } else {
        //     queryParams.perPage = filterOptions.perPage;
        // }
        if (_.get(filterOptions, 'availability.value') == 'sold') {
            queryParams.toQuantity = 0
            //  queryParams.Statuses = ['Inactive']
            queryParams.availability = _.get(filterOptions, 'availability.value');
        } else if (_.get(filterOptions, 'availability.value') == 'available') {
            queryParams.fromQuantity = 1
            // queryParams.Statuses = ['Active']
            queryParams.availability = _.get(filterOptions, 'availability.value');
        }
        if (_.size(filterOptions.Markets) > 0) {
            var Markets = []

            _.forEach(filterOptions.Markets, item=>{
                var SubMarkets =_.get(config.warehouseData[item],'SubMarkets', [])
                if (SubMarkets.length){
                    Markets =   _.concat(Markets,SubMarkets)
                }else{
                    Markets.push(item.value)
                }
            })
            queryParams.Markets =Markets.join(',')
        }
        queryParams.addFields = _.uniq(queryParams.addFields)
        queryParams.customQueriesData = {
            '#date_1#': moment().subtract(3, 'days').startOf('day').toISOString()
        }
        var customQueries = [

            {
                "$addFields": {
                    "LastSoldAtChangeLogRecord": {
                        "$ifNull": [{
                            "$arrayElemAt": [{
                                "$filter": {
                                    "input": "$ChangeLog",
                                    "as": "changeLogObject",
                                    "cond": {
                                        "$and": [
                                            {"$eq": ["$$changeLogObject.FieldChanged", "Quantity"]},
                                            {"$eq": ["$$changeLogObject.To", '0']},
                                            //   {"$gt": ["$$changeLogObject.Date",'#date_1#']},
                                        ]
                                    }
                                }
                            }, -1]
                        }, {}]
                    }
                }

            }]
            var customQueriesSecondary =[
            {
                "$match": {

                    '$or': [
                        {"Status": 'Active'},
                        {
                            '$and': [
                                {"ProductVariants.0.Quantity": 0},
                                {"LastSoldAtChangeLogRecord.Date": {'$gt':'#date_1#'}}
                            ]
                        },
                    ]
                }
            },
                {
                    "$lookup": {
                        from: "subscriptions",
                        let: { shopify_product_id: "$ShopifyProductID" },
                        "pipeline": [
                            {
                                "$match":
                                    { $expr:
                                        { $and:
                                            [
                                                { $in: ["$Type",[   "SoldOut", "PriceDrop" ] ] },
                                                { $eq: [ "$$shopify_product_id","$ShopifyProductID",] },
                                                { $eq: [ "$Email",this.props.userReducer.user.email,] },
                                                { $eq: ["$SubscriptionCustomData.SignedUpFrom",  "dashboard"  ] }
                                            ]
                                        }
                                    }
                            }
                        ],
                        as: "ProductSubscriptions"
                    }
                },
            ]

        queryParams.customQueries = JSON.stringify(customQueries)
        queryParams.customQueriesSecondary = JSON.stringify(customQueriesSecondary)
        console.log('queryParams', queryParams);
        return {queryParams}
    }

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }

    onsearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }

    onSelectAllRecordsChange() {
        var self = this;
        if (!this.props.selectAllRecords) {

            this.props.search({include: ['_id'], all: true}).then(response => {
                this.props.toggleAllRecordsSelection(true)
                console.log('recordIds', response.data);

                self.props.dispatchAction(response.data.data, ADD_SELECTED_CONTRACTORS)
            });
        } else {
            this.props.toggleAllRecordsSelection(false);

            this.props.dispatchAction({}, CLEAR_SELECTED_CONTRACTORS)
        }
    }

    render() {
        var self = this;


        return (
            <div className="contractor-search-block bot15">

                <Row className="show-grid">
                    <Col xs={3} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            multi
                            clearable={false}
                            placeholder="Location"
                            options={    _.map( _.reject(config.warehouseData, item => {
                                return item.FulfillmentCenter
                            }), item => {
                                return {value: item.MarketName, label: item.MarketName}
                            })}
                            onChange={this.onMarketsSelect.bind(this)}
                            value={self.state.filterOptions.Markets}
                        />
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <Select
                            placeholder="Ownership"
                            clearable={true}
                            options={ config.inventoryOwnershipMap}
                            onChange={(selectedOption) => {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        inventory: selectedOption ? selectedOption : false
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.inventory}
                        />
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">

                        <Select
                            placeholder="Availability"
                            clearable={true}
                            options={ [{value: 'sold', label: 'Sold',}, {value: 'available', label: 'Available',}]}
                            onChange={(selectedOption) => {

                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        availability: selectedOption ? selectedOption : false
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.availability}
                        />
                    </Col>
                </Row>
                <Row  >
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                  isValidDate={  (date) => {
                                      if (moment(date).isBefore(moment().subtract(2, 'weeks'), 'day')) {
                                          return false;
                                      }
                                      return true
                                  }}
                                  onChange={(option) => {
                                      console.log('is before', option);
                                      if (option && moment(option, 'MM-DD-YYYY').isValid() && moment(option, 'MM-DD-YYYY').isBefore(moment().subtract(2, 'weeks'), 'day')) {
                                          return;
                                      }
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              fromPublishedAt: option,
                                          }
                                      }, function () {
                                          this.props.search();
                                      });
                                  }}
                                  value={this.state.filterOptions.fromPublishedAt}
                                  inputProps={{placeholder: 'Date Listed From'}}
                        />
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={false}
                                  onChange={(option) => {
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              toPublishedAt: option,
                                          }
                                      }, function () {
                                          this.props.search();
                                      });
                                  }}
                                  inputProps={{placeholder: 'Date Listed To'}}
                                  value={this.state.filterOptions.toPublishedAt}

                        />
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.minPrice}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={(e) => {
                                         this.setState({
                                             'filterOptions': {
                                                 ...this.state.filterOptions,
                                                 minPrice: e.target.value,
                                             }
                                         }, function () {
                                             this.props.search();
                                         })
                                     }}
                                     placeholder="Price From"/>
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.maxPrice}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={(e) => {
                                         this.setState({
                                             'filterOptions': {
                                                 ...this.state.filterOptions,
                                                 maxPrice: e.target.value,
                                             }
                                         }, function () {
                                             this.props.search();
                                         })
                                     }}
                                     placeholder="Price To"/>
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onsearchTextChange.bind(this)}
                                     placeholder="Search text"/>
                    </Col>


                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" onClick={(event) => self.props.search({})}
                                type="button">
                            Search
                        </button>
                    </Col>
                </Row>
            </div>
        );
    }
}



